import React, { Component } from 'react';
import { scaleLinear, scalePow }  from 'd3-scale';
import { arc }  from 'd3-shape';

import { Label }  from './Label';
import { formatYear, formatAxisYearSmaller } from './formats';

import './Timewheel.css';


class TimewheelThumb extends Component {

  circularScale =  scaleLinear().range([80, 500]).domain([0,2]);
  radialScale = scaleLinear().domain([-12000, 3000]).range([0, 2*Math.PI]);
  treshold = -1000;
  rings = 2;

  radialScale = function(d) {
    if ( d > this.treshold) {
      return scaleLinear().domain([-12000, 3000])
      .range([0, 2* Math.PI])(d);
    } else {
      return scalePow()
        .exponent(0.4).domain([-350000, 8000])
        .range([0, 2* Math.PI])(d);
    }
  }
  radialTicks = function(d) {
    return (
      scalePow()
        .exponent(0.4).domain([-350000, 8000])
        .range([0, 2* Math.PI])
        .ticks(200)
      .filter(d => d < this.treshold)
      .concat([-9000, -7000, -5000, -3000, -1000])
      .concat([-500, -250, 0,250, 500, 1000, 1500, 2000])
    //  .concat([new Date().getFullYear()])
    )
  }

  constructor(props){
    super(props);

    // init states, scales and other helpers
    this.state = {
        width: this.props.width || 400,
        height: this.props.height || 400,
        center:0,
        radius:300,
        arcWidth:50
      }
    this.ticks = this.radialTicks();

  }

  initSizeAndRotation(props) {
    var center;

    if ( !props.end ) {
        center = this.radialScale(parseInt(props.start || 0));
        this.setState( {center: center });
    } else {
        center = (this.radialScale(parseInt(props.end))  +  this.radialScale(parseInt(props.start || 0))) / 2;
        this.setState( {center: center });
    }

    this.setState( {rotation: 315 - this.rad2deg(center)});

    var length = Math.min( this.state.width,   this.state.height) - 120;
    var arcWidth = length / (this.rings + 1);

    this.circularScale = scaleLinear()
      .range([0, length])
      .domain([0, (this.rings + 1)]);

    this.setState( {radius: length });
    this.setState( {arcWidth: arcWidth });
  }

  componentWillReceiveProps(nextProps) {
    this.initSizeAndRotation(nextProps)
  }

  componentWillMount() {
    this.initSizeAndRotation(this.props);
  }

  componentDidMount() {

  }

  componentWillUnmount() {

  }

  render() {
    return (
      <div className="TimewheelThumb" >

        <svg ref={node => this.node = node}
          width={this.state.width} height={this.state.height}>

          <g transform={"translate(15, " + (this.state.height-15) + ")"}>

            <g transform={"rotate(" + this.state.rotation + ")"}>

              <g className="circularAxis">
                  <circle x="0" y="0" r={this.circularScale(2.8)} />
                  <circle x="0" y="0" r={this.circularScale(1.8)} />
                  <circle x="0" y="0" r={this.circularScale(1)} />
              </g>

              <g className="radialAxis"> {
                  this.ticks.map( (d,i) => (
                    <g key={i} transform={'rotate('
                      + (this.rad2deg(this.radialScale(d)) )
                      + ')'}>
                      <line
                        x1={ this.circularScale(0.9) }
                        x2={ d % 5000 === 0 ? this.state.radius * 1.01 : this.state.radius * 0.97}
                        style={{
                          opacity: d < -20000 ? '0.7' : '0.9',
                          display: d < -300000 ? "none" : ""
                        }}
                        className= {
                          (d <= -5000 && d % 5000 === 0)
                          || (d > -5000 && d % 1000 === 0 )
                          ? 'hl' : null}
                      />
                      <text x={ this.state.radius * 1.08  }>
                        { formatAxisYearSmaller(d) }
                      </text>
                    </g>
                  ))
                }
              </g>

              <g className="current stronger  "> {
                <g transform={'rotate('
                  + (this.rad2deg(this.radialScale(this.props.start)) )
                  + ')'}>
                  <line
                    x1={ this.circularScale(.1) }
                    x2={ this.state.radius * 1.05  }
                  />
                </g> }
                { this.props.end &&
                  <g transform={'rotate('
                    + (this.rad2deg(this.radialScale(this.props.end)) )
                    + ')'}>
                    <line
                      x1={ this.circularScale(.1) }
                      x2={ this.state.radius * 1.05 }
                    />
                  </g>
                }
                { this.props.end &&
                  <path d={
                    arc()( {
                      innerRadius: this.circularScale(.1),
                      outerRadius: this.state.radius * 0.97,
                      startAngle: this.radialScale(this.props.start) + this.deg2rad(90),
                      endAngle: this.radialScale(this.props.end) + this.deg2rad(90)
                    })
                  } />
                }
                <circle r={ this.circularScale(.75) } />
                <Label
                  x={ this.state.radius * .66 * Math.cos(this.state.center)}
                  y={ this.state.radius * .66 * Math.sin(this.state.center)}
                  angle={this.rad2deg(this.state.center) + 45}
                  scale="1.3">
                { formatYear(this.props.start) +  ( this.props.end ? " - " +  formatYear(this.props.end) : "" )}
                </Label>
              </g>

            </g>



          </g>
          
        </svg>

      </div>

    );
  }

  rad2deg(angle) {
    return angle * 180 / Math.PI;
  }

  deg2rad(d) {
    return d / 180 * Math.PI;
  }
}


TimewheelThumb.defaultProps = {
    "start" : 0,
    "end": 1300
}


export default (TimewheelThumb)
